module.exports = __webpack_public_path__ + "img/card-emtenan-11.12892e0f.jpg";